import React from "react";
import { Checkbox as CheckboxOption, ClearAllButton } from "./styles";
import { CheckboxChangeEvent } from "antd/lib/checkbox";
import { Typography } from "antd";
import { Flex } from "css/styles";

type CheckboxOptionsProps = {
  selectAll?: { allow: boolean; label: string };
  options: { value: string; label: string | JSX.Element }[];
  value: string[];
  onChange: (value: string[]) => unknown;
};

type CheckboxProps = { title: string; clearAll?: { allow: boolean; label?: string } } & CheckboxOptionsProps;

function CheckboxOptions({ selectAll, options, value, onChange }: CheckboxOptionsProps) {
  const handleChange = (e: CheckboxChangeEvent) => {
    if (e.target.checked) {
      value = e.target.value ? [...value, e.target.value] : options.map((o) => o.value);
    } else {
      value = e.target.value ? value.filter((v) => v !== e.target.value) : [];
    }
    return onChange(value);
  };
  return (
    <Flex direction="column" align="start" gap=".5em">
      {selectAll?.allow && (
        <CheckboxOption
          indeterminate={!!value.length && value.length < options.length}
          checked={value.length === options.length}
          onChange={handleChange}
        >
          {selectAll.label}
        </CheckboxOption>
      )}
      {options.map((o) => (
        <CheckboxOption key={o.value} value={o.value} checked={value.includes(o.value)} onChange={handleChange}>
          {o.label}
        </CheckboxOption>
      ))}
    </Flex>
  );
}

export function CheckboxGroup(props: CheckboxProps) {
  const { title, clearAll, ...checkboxOptionProps } = props;
  return (
    <Flex align="start" justify="space-between">
      <Flex direction="column" align="start" gap=".5em">
        <Typography.Text strong>{title}</Typography.Text>
        <CheckboxOptions {...checkboxOptionProps} />
      </Flex>
      {clearAll?.allow && (
        <ClearAllButton type="link" onClick={() => checkboxOptionProps.onChange([])}>
          {clearAll.label || "Clear All"}
        </ClearAllButton>
      )}
    </Flex>
  );
}

export default CheckboxGroup;
